import React from 'react';
import { Box } from '@mui/material';
import { StepHeader, StepBox } from '../../../../shared/components/StepHeader';
import DatasetInputTabs from './DatasetInputTabs';
import DatasetPatternSection from './DatasetPatternSection';
import type { useDatasetInputTabs } from '../../hooks/useDatasetInputTabs';
import type { InputForm } from '../../utils/datasetMappingUtils';

interface DatasetEventsStepProps {
  customerId: string;
  inputs: InputForm[];
  tabs: ReturnType<typeof useDatasetInputTabs>;
  /** The saved inputs are fixed on an edit. */
  editing: boolean;
  sample: Record<string, unknown>;
  /** The selected input's errors, under the names the pattern section uses. */
  errors: Record<string, string>;
  withErrors: Set<number>;
  disabled: boolean;
  onPatternChange: (input: number, pattern: Record<string, unknown>) => void;
  onSampleChange: (sample: Record<string, unknown>) => void;
}

/** Step 1: one tab per input, each with the events it collects, tested against the sample. */
const DatasetEventsStep: React.FC<DatasetEventsStepProps> = ({
  customerId, inputs, tabs, editing, sample, errors, withErrors, disabled, onPatternChange, onSampleChange,
}) => (
  <Box>
    <StepHeader
      number={1}
      title="Which events"
      helper="The events this dataset collects, matched like a rule. Example: source aws.securityhub for Security Hub findings."
    />
    <StepBox>
      <DatasetInputTabs
        inputs={inputs}
        selected={tabs.selected}
        withErrors={withErrors}
        disabled={disabled}
        onSelect={tabs.setSelected}
        onAdd={tabs.addInput}
        onRemove={tabs.removeInput}
      />
      <DatasetPatternSection
        // Each input has its own pattern editor, so a switch shows that input's text.
        key={tabs.selected}
        customerId={customerId}
        eventPattern={tabs.input.eventPattern}
        sampleEvent={sample}
        locked={editing && tabs.input.locked}
        errors={errors}
        onPatternChange={(pattern) => onPatternChange(tabs.selected, pattern)}
        onPatternValidityChange={tabs.setPatternValid}
        onSampleChange={onSampleChange}
      />
    </StepBox>
  </Box>
);

export default DatasetEventsStep;
